import React, {
  createContext,
  PropsWithChildren,
  useCallback,
  useEffect,
} from 'react';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { isWeb } from 'shared/constants/platform';
import { useIdleTimeout } from 'shared/hooks/useIdleTimer/useIdleTimer';

interface IdleTimeoutProviderProps {
  timeoutDurationInMin?: number;
  onTimeout?: () => void;
}

const IdleTimeoutContext = createContext(undefined);

const windowEvents = [
  'load',
  'mousemove',
  'mousedown',
  'click',
  'scroll',
  'keypress',
];

const IdleTimeoutProvider = ({
  children,
  timeoutDurationInMin,
  onTimeout,
}: PropsWithChildren<IdleTimeoutProviderProps>) => {
  const { resetIdleTimer } = useIdleTimeout(timeoutDurationInMin, onTimeout);
  const handleUserInteraction = () => {
    resetIdleTimer();
  };

  useEffect(() => {
    const manageEventListeners = (action: 'add' | 'remove') => {
      if (!isWeb) {
        return;
      }
      windowEvents.forEach((event) => {
        const method =
          action === 'add' ? 'addEventListener' : 'removeEventListener';
        window[method](event, resetIdleTimer);
      });
    };

    manageEventListeners('add');

    return () => manageEventListeners('remove');
  }, [resetIdleTimer]);

  const onLayoutRootView = useCallback(async () => {}, []);

  return (
    <IdleTimeoutContext.Provider value={undefined}>
      <GestureHandlerRootView
        onLayout={onLayoutRootView}
        onTouchStart={handleUserInteraction}
      >
        {children}
      </GestureHandlerRootView>
    </IdleTimeoutContext.Provider>
  );
};

export { IdleTimeoutProvider };
